import { Box, Flex, Text } from '@chakra-ui/react';
import { CustomExclamationMarkIcon } from '../../../theme/icons/CustomExclamationMarkIcon';

const SoftLimitExceededBanner = ({ entitlement }) => {
  return (
    <Box
      p={2}
      mb={6}
      bg="warningOrangeLight"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="10px"
      w="100%"
    >
      <Flex direction="row" alignItems="center" gap={2}>
        <CustomExclamationMarkIcon boxSize="20px" m={4} color="warningOrange" />
        <Box>
          <Text textStyle="bodyFamilyMedium" fontSize="14px">
            You've exceeded your limit
          </Text>
          <Text fontSize="14px">
            You've gone over your plan's soft limit for{' '}
            {entitlement.name.toLowerCase()}. You can continue using this
            feature for now, but action is required to avoid interruption.
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default SoftLimitExceededBanner;
